// extracted by mini-css-extract-plugin
export default {"fr-view":"QRCode_fr-view__XV1+r","container":"QRCode_container__BK7Cy"};